export default __webpack_public_path__ + "static/media/tipright.c0f66f8d.png";